import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const videos = [
  { id: 0, url: 'https://www.youtube.com/embed/w_ME3HOlVns' },
  { id: 1, url: 'https://www.youtube.com/embed/GiOUxcJdsr4' },
  { id: 3, url: 'https://www.youtube.com/embed/rgb9BkmHozM' },
  { id: 4, url: 'https://www.youtube.com/embed/7pyizNJN6zo' }
];

const VideosSection = () => {
  const { t } = useLanguage();

  return (
    <section id="videos" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-slate-900 mb-6">
            <span style={{ color: '#1F4FD8' }}>{t.videos.title}</span>
          </h2>
          <p className="text-xl text-slate-600">
            {t.videos.subtitle}
          </p>
        </div>

        {/* Videos Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {videos.map((video) => (
            <div
              key={video.id}
              className="group relative bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300"
            >
              <div className="aspect-video relative">
                <iframe
                  src={video.url}
                  title={`SMARTMICRO video ${video.id}`}
                  className="w-full h-full"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>
            </div>
          ))}
        </div>

        {/* Link to SMARTMICRO */}
        <div className="mt-12 text-center">
          <p className="text-slate-600 mb-4">
            {t.videos.moreInfo}
          </p>
          <a
            href="https://www.SMARTMICRO.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full text-white font-semibold transition-all hover:-translate-y-0.5"
            style={{ backgroundColor: '#1F4FD8', boxShadow: '0 4px 15px rgba(31, 79, 216, 0.25)' }}
          >
            {t.videos.visitSite}
            <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
              <polyline points="15 3 21 3 21 9" />
              <line x1="10" y1="14" x2="21" y2="3" />
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
};

export default VideosSection;
